<feature-page-layout-notification-banner></feature-page-layout-notification-banner>
<div id="wrapper">
  <ng-container *featureLoadingNavbarSkeleton="7; isLoading: isLoading">
    <shared-ui-navbars-navbar [items]="menuItems" *ngIf="user$ | async; let user">
      <shared-ui-navbars-navbar-header
        [heading]="user.fullName"
        [subheading]="user.role | userRoleToString"
        [imageUrl]="user.imageUrl"
        [subheadingDropdown]="menuService.getHeaderMenuItems() | async"
        [userDetailsInDropdown]="false"
      ></shared-ui-navbars-navbar-header>
    </shared-ui-navbars-navbar>
  </ng-container>

  <div id="page-wrapper" [ngClass]="[isSideBarHidden()]" class="gray-bg">
    <feature-notification-handling-notification></feature-notification-handling-notification>

    <div [ngClass]="[isNavMenuHidden()]" class="row p-2">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-3">
              <shared-ui-buttons-button (action)="navbarToggle()" [type]="buttonType.Primary" [size]="buttonSize.Default" [icon]="iconType.Bars"></shared-ui-buttons-button>
            </ul>
            <div class="nav navbar-top-links navbar-right fw-bold">
              <a class="text-black-50 m-2 me-3" [href]="'support-button-email-address' | translate"
                ><shared-ui-icons-icon [iconName]="iconType.Question"></shared-ui-icons-icon>
                <span class="ms-2">{{ 'layout-one-support' | translate }}</span>
              </a>

              <a class="text-black-50 m-2" (click)="authService.logout()"
                ><shared-ui-icons-icon [iconName]="iconType.Logout"></shared-ui-icons-icon>
                <span class="ms-2">{{ 'layout-one-logout' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <ng-content></ng-content>

    <shared-ui-page-toolbars-footer [text]="'layout-one-footer' | translate"></shared-ui-page-toolbars-footer>
  </div>
</div>
<feature-page-layout-google-analytics-tracking></feature-page-layout-google-analytics-tracking>
<feature-page-layout-microsoft-clarity-tracking></feature-page-layout-microsoft-clarity-tracking>
